// src/components/reports/ReportLayout.js
import React from "react";

/**
 * ReportLayout
 *
 * Standard layout wrapper for all Reports pages.
 *
 * Props:
 * - title: string
 * - subtitle?: string
 * - actions?: ReactNode (buttons, filters, export, etc.)
 * - loading?: boolean
 * - error?: string
 * - children: ReactNode
 */
export default function ReportLayout({
  title,
  subtitle,
  actions,
  loading = false,
  error = "",
  children,
}) {
  return (
    <div className="p-6 space-y-6 max-w-7xl">
      {/* Header */}
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-1 text-sm text-gray-500">
              {subtitle}
            </p>
          )}
        </div>

        {actions && (
          <div className="flex items-center gap-2">
            {actions}
          </div>
        )}
      </div>

      {/* Error */}
      {error && (
        <div className="rounded-xl border border-rose-200 bg-rose-50 p-4 text-sm text-rose-700">
          {error}
        </div>
      )}

      {/* Loading */}
      {loading ? (
        <div className="rounded-xl border bg-white p-6 text-sm text-gray-500">
          Loading report…
        </div>
      ) : (
        <div className="space-y-6">
          {children}
        </div>
      )}
    </div>
  );
}